export enum Stage {
  INITIALIZING = 'INITIALIZING',
  SETTLED = 'SETTLED',
}
import { INITIAL_SEARCH_STATE } from './constants'

export interface SearchContextProps {
  handleSearch: (
    rid?: string,
    adminAuthToken?: string,
    searchFilters?: boolean
  ) => Promise<void>
  searchState: typeof INITIAL_SEARCH_STATE
  searchResults: any[]
  setSearchState: React.Dispatch<
    React.SetStateAction<typeof INITIAL_SEARCH_STATE>
  >
  updateSearchProperty: (
    property: keyof typeof INITIAL_SEARCH_STATE,
    value: any
  ) => void
  clearSearchState: () => void
  filters: { [x: string]: any }
  nextPage: (adminAuthToken?: string) => Promise<void>
  hasMore: boolean
  loading: boolean
  overview: any
  pageNum: number
  setPreselectedJobFromJobRef: (jobId: any) => Promise<any>
  preSelectedJob: any
  clearPreSelectedJob: () => void
  searchByCompanyName: (company_name: string) => void
  lastFilterAdded: keyof typeof INITIAL_SEARCH_STATE
  numberOfResults: number[]
  addCustomFilter: (
    field: string,
    newFilter: {
      key: string
      pretty_name: string
    }
  ) => void
  removeCustomFilter: (field: string, key: string) => void
  removeCustomFiltersInField: (field: string) => void
  isReadyForSearchStateSideEffects: boolean
  removeLastFilterAdded: () => void
  fetchJobByJobRef: (jobRef: any) => Promise<any>
  filtersLoading: boolean
}

export const FULL_REVENUE_FILTERS = [
  'lt_revenue_per_apply',
  'gt_revenue_per_apply',
  'lt_revenue_per_click',
  'gt_revenue_per_click',
  'lt_revenue_per_hire',
  'gt_revenue_per_hire',
] as const

type ShortenedRevenueFiltersProps =
  | 'revenue_per_apply'
  | 'revenue_per_click'
  | 'revenue_per_hire'

export const SHORTENED_REVENUE_FILTERS: {
  filters: ShortenedRevenueFiltersProps[]
} = {
  filters: ['revenue_per_apply', 'revenue_per_click', 'revenue_per_hire'],
}
